import React, { useEffect, useState } from 'react'
import _ from 'lodash'
import {
  ModalHeader,
  ModalBody,
  Card, CardBody, 
  Button,
  Input, Label, FormGroup,
  Row, Col
} from 'reactstrap';

import Lang from 'Lang/General'

import ImageField from 'components/ImageField/index'

const DefaultFormValue = {
  promo_code: '',
  stand_number: '',
  email_banner: {
    url: '',
    raw: '',
    filename: ''
  },
  social_media: {
    url: '',
    raw: '',
    filename: ''
  },
  press_release_1: {
    url: '',
    raw: '',
    filename: ''
  },
  press_release_2: {
    url: '',
    raw: '',
    filename: ''
  },
}

function UploadModalContent(props) {

  const [formData, setFormData] = useState(DefaultFormValue)

  useEffect(() => {
    if(props.selectedBooking) {
      setFormData(props.selectedBooking)
    }
  }, [props.selectedBooking])

  return (
    <>
      {
        (props.selectedPortalUsers && props.selectedBooking) && (
          <>
            <ModalHeader toggle={() => props.onClose()}>
              {
                props.selectedPortalUsers?.company_name??'' 
              }
              { ` - ` }
              {
                _.find(props.selectedPortalUsers?.fairs, {id: props.selectedBooking?.fair_id})?.title??''
              }
            </ModalHeader>
            <ModalBody>
              <Card className={'mt-4 mb-2'}>
                <CardBody>
                  <Row>
                    {
                      props.selectedPortalUsers.role !== 'SPEAKER' && (
                        <>
                          <Col lg={6}>
                            <FormGroup>
                              <Label>
                                {Lang['STAND_NUMBER'][props.data.languageReducer.userSettings.admin_panel_language]}
                              </Label>
                              <Input
                                value={ formData.stand_number }
                                onChange={ e => setFormData({
                                  ... formData,
                                  stand_number: e.target.value
                                })}
                              />
                            </FormGroup>
                          </Col>
                        </>
                      )
                    }
                    <Col lg={6}>
                      <FormGroup>
                        <Label>
                          {Lang['PROMO_CODE'][props.data.languageReducer.userSettings.admin_panel_language]}
                        </Label>
                        <Input
                          value={ formData.promo_code }
                          onChange={ e => setFormData({
                            ... formData,
                            promo_code: e.target.value
                          })}
                        />
                      </FormGroup>
                    </Col>
                    <Col lg={12}>
                      <FormGroup>
                        <Label>
                          {Lang['SOCIAL_MEDIA_POST'][props.data.languageReducer.userSettings.admin_panel_language]}
                        </Label>
                        <ImageField
                          fileName={formData.social_media?.filename??''}
                          fileValue={formData.social_media?.url??''}
                          onChange={val => setFormData({
                            ... formData,
                            social_media: {
                              ... formData.social_media,
                              ... val
                            }
                          })}
                        />
                      </FormGroup>
                    </Col>
                    <Col lg={12}>
                      <FormGroup>
                        <Label>
                          {Lang['EMAIL_BANNER'][props.data.languageReducer.userSettings.admin_panel_language]}
                        </Label>
                        <ImageField
                          fileName={formData.email_banner?.filename??''}
                          fileValue={formData.email_banner?.url??''}
                          onChange={val => setFormData({
                            ... formData,
                            email_banner: {
                              ... formData.email_banner,
                              ... val
                            }
                          })}
                        />
                      </FormGroup>
                    </Col>
                    {
                      props.selectedPortalUsers.role !== 'SPEAKER' && (
                        <>    
                          <Col lg={12}>
                            <FormGroup>
                              <Label>
                                {Lang['PRESS_RELEASE'][props.data.languageReducer.userSettings.admin_panel_language]}
                                {
                                  ` 1`
                                }
                              </Label>
                              <ImageField
                                acceptType={ 'application/pdf' }
                                fileName={formData.press_release_1?.filename??''}
                                fileValue={formData.press_release_1?.url??''}
                                onChange={val => setFormData({
                                  ... formData,
                                  press_release_1: {
                                    ... formData.press_release_1,
                                    ... val
                                  }
                                })}
                              />
                            </FormGroup>
                          </Col>
                          <Col lg={12}>
                            <FormGroup>
                              <Label>
                                {Lang['PRESS_RELEASE'][props.data.languageReducer.userSettings.admin_panel_language]}
                                {
                                  ` 2`
                                }
                              </Label>
                              <ImageField
                                acceptType={ 'application/pdf' }
                                fileName={formData.press_release_2?.filename??''}
                                fileValue={formData.press_release_2?.url??''}
                                onChange={val => setFormData({
                                  ... formData,
                                  press_release_2: {
                                    ... formData.press_release_2,
                                    ... val
                                  }
                                })}
                              />
                            </FormGroup>
                          </Col>
                        </>
                      )
                    }
                  </Row>
                </CardBody>
              </Card>
              <small className="d-block mb-3">
                {Lang['FEX_ALERT_MSG'][props.data.languageReducer.userSettings.admin_panel_language]}
              </small>
              <div className="d-flex">
                <Button 
                  color={'primary'}
                  className={'ml-auto'}
                  onClick={() => {
                    let temp = _.cloneDeep(formData)
                    
                    temp.social_media = props.selectedBooking && formData.social_media.url === props.selectedBooking.social_media.url ? null : {
                      raw: formData.social_media.raw,
                      filename: formData.social_media.filename
                    }

                    temp.press_release_1 = props.selectedBooking && formData.press_release_1.url === props.selectedBooking.press_release_1.url ? null : {
                      raw: formData.press_release_1.raw,
                      filename: formData.press_release_1.filename
                    }

                    temp.press_release_2 = props.selectedBooking && formData.press_release_2.url === props.selectedBooking.press_release_2.url ? null : {
                      raw: formData.press_release_2.raw,
                      filename: formData.press_release_2.filename
                    }

                    temp.email_banner = props.selectedBooking && formData.email_banner.url === props.selectedBooking.email_banner.url ? null : {
                      raw: formData.email_banner.raw,
                      filename: formData.email_banner.filename
                    }

                    props.updateBooking({
                      ... temp
                    })
                  }}
                >
                  {Lang['SAVE'][props.data.languageReducer.userSettings.admin_panel_language]}
                </Button>
              </div>
            </ModalBody>   
          </>
        )
      }
    </>
  )
}

export default UploadModalContent